import { Avatar, Box, Tooltip, useTheme } from "@mui/material";
import { IconQuestionMark } from "@tabler/icons-react";
import { ThemeMode } from "config";
import React from "react";
import useLocalization from "hooks/useLocalization";
import ContactSupportModal from "components/ContactSupportModal";

interface ContactSupportSectionProps {}

const ContactSupportSection: React.FC<ContactSupportSectionProps> = () => {
  const { currentLocale } = useLocalization();
  const theme = useTheme();
  const [open, setOpen] = React.useState(false);

  return (
    <Box sx={{ ml: 2 }}>
      <Tooltip
        title={
          currentLocale.botBuilder.builderTemplate.contactSupport.title ||
          "Contact Support"
        }
      >
        <Avatar
          variant="rounded"
          sx={{
            ...theme.typography.commonAvatar,
            ...theme.typography.mediumAvatar,
            border: "1px solid",
            borderColor:
              theme.palette.mode === ThemeMode.DARK
                ? "dark.main"
                : "primary.light",
            bgcolor:
              theme.palette.mode === ThemeMode.DARK
                ? "dark.main"
                : "primary.light",
            color: "primary.dark",
            transition: "all .2s ease-in-out",
            '&[aria-controls="menu-list-grow"],&:hover': {
              borderColor: "primary.main",
              bgcolor: "primary.main",
              color: "primary.light",
            },
          }}
          aria-haspopup="true"
          onClick={() => setOpen(true)}
          color="inherit"
        >
          <IconQuestionMark />
        </Avatar>
      </Tooltip>

      <ContactSupportModal
        open={open}
        onClose={() => setOpen(false)}
      />
    </Box>
  );
};

export default ContactSupportSection;
